/**
 * Localize risk-breach reason strings emitted by the trade server.
 * Unknown reason text passes through unchanged.
 */
export function localizeRiskBreachReason(reason, t) {
  if (reason == null || reason === '') return reason;
  const raw = String(reason).trim();

  let m = raw.match(
    /^Daily loss\s+(.+?)%\s+reaches or exceeds limit\s+-(.+?)%\s+of balance$/i,
  );
  if (m) {
    return t('notifications.msg.riskDailyLoss', {
      loss: m[1].trim(),
      limit: m[2].trim(),
    });
  }

  m = raw.match(
    /^Overall drawdown\s+(.+?)%\s+exceeds limit\s+-(.+?)%\s+of balance$/i,
  );
  if (m) {
    return t('notifications.msg.riskOverallDrawdown', {
      drawdown: m[1].trim(),
      limit: m[2].trim(),
    });
  }

  m = raw.match(/^Open trades\s+(.+?)\s+exceeds limit\s+(.+)$/i);
  if (m) {
    return t('notifications.msg.riskOpenTrades', {
      count: m[1].trim(),
      limit: m[2].trim(),
    });
  }

  m = raw.match(
    /^Position margin\s+(.+?)\s+exceeds limit\s+(.+?)\s+\(positions:\s*(.+)\)$/i,
  );
  if (m) {
    return t('notifications.msg.riskPositionMargin', {
      margin: m[1].trim(),
      limit: m[2].trim(),
      positions: m[3].trim(),
    });
  }

  if (/^unknown breach$/i.test(raw)) {
    return t('notifications.msg.riskUnknownBreach');
  }

  return raw;
}

export function localizeRiskBreachReasons(reasons, t) {
  if (!Array.isArray(reasons) || reasons.length === 0) {
    return t('notifications.msg.riskUnknownBreach');
  }
  return reasons.map((r) => localizeRiskBreachReason(r, t)).join(', ');
}

export function formatRiskBreachToast(reasons, t) {
  const localized = localizeRiskBreachReasons(reasons, t);
  return `🔒 ${t('notifications.msg.accountLockedRiskBreach', {
    reasons: localized,
  })}`;
}
